<template>
  <div class="container">
    <mt-header class="header" title="购买完成">
      <header-item slot="left" v-bind:isBack=true v-on:onclick="goBack">
      </header-item>    
    </mt-header>
    <div class="wrapper">
      <img class="photo" v-if="this.isExchange" src="../../assets/image/change-icon/h2_icon_gift@2x.png">
      <img class="photo" v-else src="../../assets/image/change-icon/e2_order_ok@2x.png">
      <label class="title" v-if="this.isExchange">恭喜您，兑换成功</label>
      <label class="title" v-else>订单提交成功</label>
      <gk-button class="button left-button" type="primary" v-on:click="goDetail">订单详情</gk-button>
    </div>
    <div class="subtitle">
      <img class="photo"  src="../../assets/image/profile/you_like.png">
      猜你喜欢
      <img class="photo"  src="../../assets/image/profile/you_like.png">
    </div>
    <products></products>
  </div>
</template>

<script>
import { HeaderItem, Button } from '../../components/common'
import { Header, MessageBox } from 'mint-ui'
import { ENUM } from '../../const/enum'
import products from './children/ProductList'
export default {
  components: {
    products,
  },
  data() {
    return ({
      isExchange: this.$route.query.isExchange ? this.$route.query.isExchange : false,
    });
  },
  mounted(){
    // window.location.reload()
  },
  methods: {
    goBack() {      
      this.$router.push({ name: 'order', params: { order: ENUM.ORDER_STATUS.PAID }});
    },
    goDetail() {
      let order = this.$cookie.get('orderid');
      let orderId = order ? order : this.$route.query.order;
      this.$router.push({ name: 'orderDetail', query: {id: orderId, isFromPay: true }})      
    },
    goShopping() {
      this.$router.push('/home')
    },
  }
}
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: $mainbgColor;
  }
  .header {
    @include header;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 10%;
  }
  .photo {
    width: 75px;
    height: 75px;
  }
  .title {
    color: #A4AAB3;
    font-size: 17px;
    margin-top: 27px;
    text-align: center;
  }
  .button {      
    @include button; 
    width: 180px;
    height: 36px;
    margin-top: 24px;     
  }
  .subtitle{
    margin-top: 30px;
    height:20px;
    align-items: center;
    text-align: center;
    padding: 10px 10px;
    font-size: 20px;
    line-height: 20px;
    font-weight: 500;
    color: red;
    img{
      height:20px;
      line-height: 20px;
      width: 20px;
      margin: 0 auto;
    }
  }
</style>





// WEBPACK FOOTER //
// src/page/payment/PaySucceed.vue